import React from 'react';
import './ProcessingIndicator.css';

const ProcessingIndicator = ({ message = "Processing...", progress = null }) => {
    return (
        <div className="processing-indicator">
            <div className="spinner"></div>
            <p className="processing-message">{message}</p>
            {progress !== null && (
                <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                </div>
            )}
        </div>
    );
};

export default ProcessingIndicator;
